import React from 'react';

const variants = {
  healthy: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  moderate: 'bg-amber-50 text-amber-700 border-amber-100',
  elevated: 'bg-orange-50 text-orange-700 border-orange-100',
  critical: 'bg-rose-50 text-rose-700 border-rose-100',
  neutral: 'bg-indigo-50 text-indigo-700 border-indigo-100',
  ghost: 'bg-slate-50 text-slate-600 border-slate-200'
};

export const StatusPill = ({ label, variant = 'neutral', className = '' }) => {
  return (
    <span className={`px-2.5 py-1 rounded-full text-[10px] font-black uppercase tracking-widest border ${variants[variant]} ${className}`}>
      {label}
    </span>
  );
};